import { Registry } from "@react-registry"
import { insertBlockTextInsideCode } from "./utils"


export const withCode = (editor) => {
    const { insertData } = editor

    editor.insertData = (data) => { 
        const isInserted = insertBlockTextInsideCode(data, editor)
        if(!isInserted) insertData(data)
    }
  
    return editor
  }
  
  Registry.register(withCode, { id: 'withCode', registry: 'plugin' })